import React from 'react';
import { LayoutDashboard, GitPullRequest, Settings, BookOpen, Scale } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';

interface DashboardSidebarProps {
  onSelect: (key: string) => void;
  selectedKey: string;
  className?: string;
}

const DashboardSidebar: React.FC<DashboardSidebarProps> = ({ onSelect, selectedKey, className }) => {
  const navigate = useNavigate();

  const menuItems = [
    { key: 'overview', label: 'Overview', icon: <LayoutDashboard className="h-4 w-4" />, route: '/dashboard?tab=overview' },
    { key: 'repositories', label: 'Repositories', icon: <GitPullRequest className="h-4 w-4" />, route: '/dashboard?tab=repositories' },
    { key: 'rules', label: 'Rules Library', icon: <Scale className="h-4 w-4" />, route: '/rules' },
    { key: 'docs', label: 'Documentation', icon: <BookOpen className="h-4 w-4" />, route: '/docs' },
    { key: 'settings', label: 'Settings', icon: <Settings className="h-4 w-4" />, route: '/dashboard?tab=settings' },
  ];

  return (
    <aside className={cn("w-full", className)}>
       <nav className="flex flex-col">
          {menuItems.map(item => (
             <button
                 key={item.key}
                 className={cn(
                     "flex items-center w-full px-6 py-4 text-sm font-mono uppercase tracking-wide border-b border-neutral-950 dark:border-neutral-100 transition-colors text-left",
                     selectedKey === item.key
                         ? "bg-neutral-950 text-neutral-50 dark:bg-neutral-100 dark:text-neutral-950 font-bold"
                         : "hover:bg-neutral-100 dark:hover:bg-neutral-900 text-muted-foreground hover:text-foreground"
                 )}
                 onClick={() => {
                   if (item.key === 'rules' || item.key === 'docs') {
                        navigate(item.route);
                   } else {
                        onSelect(item.key);
                        if (item.route) {
                            navigate(item.route);
                        }
                   }
                 }}
             >
                 {React.cloneElement(item.icon as React.ReactElement, {
                     className: cn("h-4 w-4 mr-3", selectedKey === item.key ? "text-neutral-50 dark:text-neutral-950" : "text-muted-foreground group-hover:text-foreground")
                 })}
                 {item.label}
             </button>
         ))}
       </nav>

       <div className="p-6">
           <div className="p-4 border border-neutral-950 dark:border-neutral-100 bg-white dark:bg-neutral-950 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,1)]">
               <p className="font-mono text-[10px] text-muted-foreground uppercase mb-2">System Status</p>
               <div className="flex items-center gap-2">
                   <div className="w-2 h-2 bg-green-500 animate-pulse rounded-full"></div>
                   <span className="font-mono text-xs font-bold">OPERATIONAL</span>
               </div>
           </div>
       </div>
    </aside>
  );
};

export default DashboardSidebar;
